export default function PresentTense() {
  return (
    <table className="table_sticky">
      <tbody>
        <tr style={{ fontWeight: "bold" }}>
          <th>
            <em>infinitive</em>
          </th>
          <td> děla-ti </td>
          <td> prosi-ti </td>
          <td> nes-ti </td>
        </tr>
        <tr>
          <th> ja </th>
          <td> děla-m </td>
          <td> prosi-m </td>
          <td> nes-e-m </td>
        </tr>
        <tr>
          <th> ty </th>
          <td> děla-š </td>
          <td> prosi-š </td>
          <td> nes-e-š </td>
        </tr>
        <tr>
          <th> on/ona/ono </th>
          <td> děla </td>
          <td> prosi </td>
          <td> nes-e </td>
        </tr>
        <tr>
          <th> my </th>
          <td> děla-mo </td>
          <td> prosi-mo </td>
          <td> nes-e-mo </td>
        </tr>
        <tr>
          <th> vy </th>
          <td> děla-te </td>
          <td> prosi-te </td>
          <td> nes-e-te </td>
        </tr>
        <tr>
          <th> oni </th>
          <td> děla-j-ut </td>
          <td> prosi-j-ut </td>
          <td> nes-ut </td>
        </tr>
      </tbody>
    </table>
  )
}
